import React from 'react';
import {connect} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import {Icon} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {get} from 'lodash';
import TextField from '@material-ui/core/TextField';
import {hasAccess} from '../../app/user';
import DVRSnapshots from '../../DVRSnapshots/component/DVRSnapshots';
import DVRSnapshotsCarousel from '../../DVRSnapshots/component/DVRSnapshotsCarousel';
import {unpairDvrOffline, loadDVRs, clear} from '../DVRhealthActions';
import SdCardStatus from '../component/SdCardStatus';
import DVRErrorsPanel from '../component/DVRErrorsPanel';
import DVRInfoTable from '../component/DVRInfoTable';
import MobileDVRCardDetail from '../component/MobileDVRCardDetail';
import DVRHealthStatus from '../DVRHealthStatus';

class DVRCardDetail extends React.Component {
  state = {
    dvrUnpairOpen: false,
    dvrUnpairEnabled: false
  };

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps = nextProps => {
    this.setState({
      dvrUnpairOpen: false,
      dvrUnpairEnabled: false
    });
  }

  handleUnpairDvr = () => {
    this.props.unpairDvrOffline(this.props.serialNo, this.props.dvrFilter.applied);
    this.props.onClose();
  }

  handleUnpairDvrOpen = () => {
    this.setState({
      dvrUnpairOpen: true
    });
  }

  handleUnpairDvrCancel = () => {
    this.setState({
      dvrUnpairOpen: false,
      dvrUnpairEnabled: false
    });
  }

  handleDvrUnpairTextChanged = e => {
    const unlockWord = I18n.t('page.dvrHealth.dvr.unpair.dialog.unlockWord');
    this.setState({
      dvrUnpairEnabled: e.target.value === unlockWord
    });
  };

  isSdCardHealthAlert = () => {
    let isFaulty = false;
    if(this.props.health.alerts) {
      this.props.health.alerts.forEach(alert => {
        if (alert.type === 'sdcardhealthunchecked') {
          isFaulty = true;
        }
      });
    }
    return isFaulty;
  }

  getDvrStatus() {
    const {substatus} = this.props;
    return DVRHealthStatus.forSubstatus(substatus);
  }

  renderDialogContent() {
    if (this.state.dvrUnpairOpen) {
      return;
    }

    const {
      health,
      serialNo,
      substatus,
      machineType,
      customer,
      channels
    } = this.props;

    const pairingMethod = get(customer, 'data.dvrPairing.method', 'dsn');

    return (
      <React.Fragment>
        <DialogContent className={`dvrcard__dialogcontmedia ${this.props.dvrSnapshotsCarouselOpened ? null : 'hideme'}`}>
          <DVRSnapshotsCarousel machineType={machineType} />
        </DialogContent>
        <DialogContent className={this.props.dvrSnapshotsCarouselOpened ? 'hideme' : 'dvrcard__dialog-parent'}>
          <DialogContentText className="dvrcard__dialog">
            <Grid container>
              <Grid item md={6}>
                <DVRSnapshots serialNumber={serialNo} machineType={machineType} dvrChannels={channels} />
                <DVRErrorsPanel substatus={substatus} alerts={health.alerts} pairingMethod={pairingMethod} />
              </Grid>

              <Grid item md={6}>
                <div>
                  <h4 className="dvrcard__infotitle"><Icon className="dvrcard__infotitle-icon">info_outline</Icon>{I18n.t('page.dvrHealth.dvr.dvrInfoTitle')}</h4>
                  <DVRInfoTable {...this.props} />
                  <div className="sdcard__cont">
                    <SdCardStatus sdcard={get(this.props, 'health.sdcard', {})} alertsCheck={this.isSdCardHealthAlert()} />
                  </div>
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        {hasAccess([
          'changeCustomer',
          'videoIntelligenceAdmin',
          'videoIntelligenceInternal']) &&
          <DialogActions className={this.props.dvrSnapshotsCarouselOpened ? 'hideme' : 'dvrcard__dialogactions'}>
            <Button
              id="unpairDvrButton"
              className="btn btn-danger"
              autoFocus
              onClick={this.handleUnpairDvrOpen}
            >
              {I18n.t('page.dvrHealth.dvr.unpair.button')}
            </Button>
          </DialogActions>
        }
      </React.Fragment>
    );
  }

  renderUnpairContent() {
    if (!this.state.dvrUnpairOpen) {
      return;
    }

    return (
      <React.Fragment>
        <DialogContent>
          <DialogContentText>
            <h2>{I18n.t('page.dvrHealth.dvr.unpair.dialog.title')}</h2>
            <p>{I18n.t('page.dvrHealth.dvr.unpair.dialog.question')}</p>
            <p>{I18n.t('page.dvrHealth.dvr.unpair.dialog.warning')} <br />
              <TextField
                id="name"
                label={I18n.t('page.dvrHealth.dvr.unpair.dialog.inputPlaceholder')}
                margin="normal"
                className="dvrcard__unpairfield"
                onChange={this.handleDvrUnpairTextChanged}
              />
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="default" className="btn btn-terciery" autoFocus onClick={this.handleUnpairDvrCancel}>
            {I18n.t('page.dvrHealth.dvr.unpair.dialog.cancel')}
          </Button>
          <Button color="danger" className="btn btn-danger" autoFocus disabled={!this.state.dvrUnpairEnabled} onClick={this.handleUnpairDvr}>
            {I18n.t('page.dvrHealth.dvr.unpair.dialog.confirm')}
          </Button>
        </DialogActions>
      </React.Fragment>
    );
  }

  render() {
    const {isMobile, substatus} = this.props;

    if (isMobile) {
      return (
        <MobileDVRCardDetail
          id={this.props.id}
          open={this.props.open}
          onClose={this.props.onClose}
          {...this.props}
          alertsCheck={this.isSdCardHealthAlert()}
        />
      );
    }

    const dvrStatus = this.getDvrStatus();

    return (
      <Dialog
        className={dvrStatus.getOverlayCssClass()}
        id={this.props.id}
        onClose={this.props.onClose}
        open={this.props.open}
      >
        <DialogTitle className={dvrStatus.getTitleCssClass(substatus)}>
          {dvrStatus.getIcon()}
          {dvrStatus.getTitle(substatus)}
        </DialogTitle>

        {this.renderDialogContent()}
        {this.renderUnpairContent()}
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  const {dvrSnapshots: {dvrSnapshotsCarouselOpened}} = state;
  return {dvrSnapshotsCarouselOpened};
};
export default connect(mapStateToProps, {unpairDvrOffline, loadDVRs, clear})(DVRCardDetail);
